<template>
  <CardModule class="mt-6" title="Taxas">
    <v-container class="px-0">
      <v-row>
        <v-col cols="12">
          <BaseMoneyField
            label="Taxa de Processamento"
            hide-details
            v-model="$marketplace.cadastro.taxa_processamento"
            placeholder="Insira a taxa de processamento"
            :options="options5"
          >
          </BaseMoneyField>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="px-0">
      <v-row class="mb-2 ml-1">
        <h1 class="cookies-text d-flex flex-row">
          Expiração
          <div class="d-flex">
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <div
                  class="info-tool d-flex align-center justify-center"
                  v-bind="attrs"
                  v-on="on"
                >
                  <InfoIcon />
                </div>
              </template>
              <span>Informe o tempo de expiração do pedido em minutos</span>
            </v-tooltip>
          </div>
        </h1>
      </v-row>
      <v-row>
        <v-divider></v-divider>
      </v-row>
      <v-row>
        <v-col cols="12">
          <BaseTextField
            label="Tempo de expiração do pedido"
            v-model="$marketplace.cadastro.exp_pedido"
            @input="$marketplace.cadastro.error.exp_pedido = []"
            :error-messages="$marketplace.cadastro.error.exp_pedido"
            placeholder="Insira o tempo de expiração do pedido"
            type="number"
          >
          </BaseTextField>
        </v-col>
      </v-row>
    </v-container>
    <ModalConfirmacao
      :textModal="$marketplace.text"
      :funcaoModal="$marketplace.funcao"
      @updateTable="$marketplace.funcaoRemover"
    />
  </CardModule>
  <!-- <PoliticaAdd /> -->
</template>

<script>
import CardModule from "@/components/cards/CardModule.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import BaseMoneyField from "@/components/forms/BaseMoneyField.vue";
import ModalConfirmacao from "@/components/global/modal-confirmacao.vue";
import InfoIcon from "@/components/icons/InfoIcon.vue";

export default {
  name: "Marketplace",
  components: {
    BaseTextField,
    CardModule,
    BaseMoneyField,
    ModalConfirmacao,
    InfoIcon,
  },
  data() {
    return {
      options5: {
        locale: "pt-BR",
        prefix: "R$",
        suffix: "",
        length: 9,
        precision: 2,
      },
      actions: [
        {
          name: "Salvar",
          action: () => this.$marketplace.validarCadastro(),
        },
        {
          name: "Cancelar",
          action: () => {
            this.$axios.rota("/home");
            location.reload();
          },
        },
      ],

      HeadersPrivacy: [
        {
          title: "Descrição",
        },
        {
          title: "Ações",
        },
      ],
    };
  },
  // components: {
  //   // PoliticaAdd: () =>
  //   //   import(
  //   //     "@/components/configuracoes/modal-configuracoes-politica-privacy.vue"
  //   //   ),
  //   // EditIcon: () => import("@/components/icons/EditIcon.vue"),
  //   // DeleteIcon: () => import("@/components/icons/DeleteIcon.vue"),
  // },
  computed: {
    privacyIsEmpty: {
      get() {
        if (
          this.$marketplace.cadastro.politica_privacidade.length <= 0 ||
          this.$marketplace.cadastro.politica_privacidade === null ||
          this.$marketplace.cadastro.politica_privacidade === undefined ||
          this.$marketplace.cadastro.politica_privacidade === ""
        ) {
          return false;
        }

        return true;
      },
      set() {},
    },
  },
  mounted() {
    this.$marketplace.getConfigMarketplace();
  },
};
</script>

<style scoped>
.marketplace-dados-config {
  width: 100%;
  height: 100%;
  align-items: center;
  flex-direction: column;
}
.taxas-text {
  font-size: 1em;
  width: 487px;
  align-self: flex-start;
  margin-top: 20px;
}
.config-plus {
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
}
.cookies-text {
  font-size: 1em;
  width: 487px;
  align-self: flex-start;
  margin-top: 20px;
}
.info-tool {
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 50px;
  margin-left: 0.625rem;
  cursor: pointer;
}
</style>
